import { render } from "./InvitationGate.vue?vue&type=template&id=399c4e7c&scoped=true"
import script from "./InvitationGate.vue?vue&type=script&lang=js"
export * from "./InvitationGate.vue?vue&type=script&lang=js"

import "./InvitationGate.vue?vue&type=style&index=0&id=399c4e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399c4e7c"]])

export default __exports__